/**
 * A JS implementation of the browser's innerHTML serialization algorithm,
 * but makes the output pretty so it can be more easily be edited.
 * See: http://www.w3.org/TR/2008/WD-html5-20080610/serializing.html#html-fragment
 * @constructor
 * @param {jQuery|string} jqOrString
 */
Foundation.HTML.Beautifier = function (jqOrString) {
  /**
   * @private
   * @type {NodeList}
   */
  this._elements = Foundation.isString(jqOrString)
               ? jQuery(`<div>${jqOrString}</div>`)[0].childNodes
               : jqOrString[0].childNodes;

  /**
   * @private
   * @type {number}
   */
  this._indentationLevel = 0;

  /**
   * @private
   * @type {string}
   */
  this._indentationString = "  ";
};

/**
 * Generate pretty HTML.
 * @return {string}
 */
Foundation.HTML.Beautifier.prototype.beautify = function () {
  return this.beautifyNodeList(this._elements).trim();
};

/**
 * @private
 * @param {Node} node
 * @return {string}
 */
Foundation.HTML.Beautifier.prototype.beautifyNode = function (node) {
  var result = "";

  switch (node.nodeType) {
    case Node.ELEMENT_NODE:
      var element = /** @type {Element} */ (node);
      result = this.beautifyElement(element);
      break;

    case Node.ATTRIBUTE_NODE:
      var attr = /** @type {Attr} */ (node);
      result = Foundation.HTML.Beautifier.stringifyAttribute(attr);
      break;

    case Node.TEXT_NODE:
    case Node.CDATA_SECTION_NODE:
      var textNode = /** @type {Text} */ (node);
      result = Foundation.HTML.Beautifier.stringifyTextNode(textNode);
      break;

    case Node.COMMENT_NODE:
      var comment = /** @type {Comment} */ (node);
      result = Foundation.HTML.Beautifier.stringifyComment(comment);
      break;

    default:
      Foundation.warn("Unexpected node type in beautifyNode()", node);
      break;
  }

  return result;
};

/**
 * @private
 * @param {Element} element
 * @return {string}
 */
Foundation.HTML.Beautifier.prototype.beautifyElement = function (element) {
  var result = "";

  // Render the opening tag.
  if (!Foundation.HTML.Beautifier.nodeIsFirst(element)) {
    result += this.prefixForOpenTag(element);
  }
  result += Foundation.HTML.Beautifier.stringifyTagNode(element);
  if (element.tagName.toLowerCase() === "br" || (element.childNodes && element.childNodes.length)) {
    result += this.postfixForOpenTag(element);
  }

  // Render the tag's children, if any.
  if (element.childNodes && element.childNodes.length) {
    result += this.beautifyNodeList(element.childNodes);
  }

  // Render the closing tag, if necessary.
  if (Foundation.HTML.Beautifier.tagNeedsClosingTag(element.tagName)) {
    if (element.childNodes && element.childNodes.length) {
      result += this.prefixForClosingTag(element);
    }
    result += `</${element.tagName.toLowerCase()}>`;
    if (!Foundation.HTML.Beautifier.nodeIsLast(element)) {
      result += this.postfixForClosingTag(element);
    }
  }

  return result;
};

/**
 * @private
 * @param {NodeList} nodes
 * @return {string}
 */
Foundation.HTML.Beautifier.prototype.beautifyNodeList = function (nodes) {
  var result = "";

  for (var i = 0; i < nodes.length; i++) {
    var child = nodes.item(i);
    result += this.beautifyNode(child);
  }

  return result;
};

/**
 * Returns the string that should come before an open tag.
 * @private
 * @param {Element} element
 * @return {string}
 */
Foundation.HTML.Beautifier.prototype.prefixForOpenTag = function (element) {
  var result = "";

  if (Foundation.HTML.Beautifier.tagNeedsSectionalTreatment(element.tagName)) {
    result += `\n${this.indentation()}`;
  }

  return result;
};

/**
 * Returns the string that should come after an open tag.
 * @private
 * @param {Element} element
 * @return {string}
 */
Foundation.HTML.Beautifier.prototype.postfixForOpenTag = function (element) {
  var result = "";

  if (Foundation.HTML.Beautifier.tagNeedsIndentation(element.tagName)) {
    this._indentationLevel += 1;
    result += `\n${this.indentation()}`;
  }
  else if (element.tagName.toLowerCase() === "br" && !Foundation.HTML.Beautifier.nodeIsLast(element)) {
    result += `\n${this.indentation()}`;
  }

  return result;
};

/**
 * Return the prefix for a closing tag.
 * @private
 * @param {Element} element
 * @return {string}
 */
Foundation.HTML.Beautifier.prototype.prefixForClosingTag = function (element) {
  var result = "";

  if (Foundation.HTML.Beautifier.tagNeedsIndentation(element.tagName)) {
    this._indentationLevel -= 1;
    result += `\n${this.indentation()}`;
  }

  return result;
};

/**
 * Return the postfix for a closing tag.
 * @private
 * @param {Element} element
 * @return {string}
 */
Foundation.HTML.Beautifier.prototype.postfixForClosingTag = function (element) {
  var result = "";

  if (Foundation.HTML.Beautifier.tagNeedsSectionalTreatment(element.tagName)) {
    result += "\n";
  }

  return result;
};

/**
 * Returns the indentation line prefix.
 * @private
 * @return {string}
 */
Foundation.HTML.Beautifier.prototype.indentation = function () {
  var result = "";

  for (var i = 0; i < this._indentationLevel; i++) {
    result += this._indentationString;
  }

  return result;
};

/**
 * @private
 * @param {number} level
 */
Foundation.HTML.Beautifier.prototype.setIndentationLevel = function (level) {
  this._indentationLevel = level;
};

/**
 * @private
 * @param {string} str
 */
Foundation.HTML.Beautifier.prototype.setIndentationString = function (str) {
  this._indentationString = str;
};

/**
 * Alias for beautify method.
 */
Foundation.HTML.Beautifier.prototype.toString = Foundation.HTML.Beautifier.prototype.beautify;



/**
 * Escape a string for use in an HTML document.
 * @private
 * @param {string} str
 * @return {string}
 */
Foundation.HTML.Beautifier.escapeText = function (str) {
  return str
    .replace(/&/g, "&amp;") // Important to do this one first.
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\u00A0/g, "&nbsp;");
};

/**
 * Escape a string for use inside a tag attribute in an HTML document.
 * @private
 * @param {string} str
 * @return {string}
 */
Foundation.HTML.Beautifier.escapeAttributeText = function (str) {
  return Foundation.HTML.Beautifier.escapeText(str)
      .replace(/"/g, "&quot;");
};

/**
 * Turn an DOM attribute node into a string.
 * @private
 * @param {Attr} attr
 * @return {string}
 */
Foundation.HTML.Beautifier.stringifyAttribute = function (attr) {
  return `${attr.name}="${Foundation.HTML.Beautifier.escapeAttributeText(attr.value)}"`;
};

/**
 * Turn a DOM comment node into a string.
 * @private
 * @param {Comment} comment
 * @return {string}
 */
 Foundation.HTML.Beautifier.stringifyComment = function (comment) {
   return `<!--${comment.data}-->`;
 };

 /**
  * Turn a DOM text node into a string.
  * @private
  * @param {Text|CDATASection} textNode
  * @return {string}
  */
 Foundation.HTML.Beautifier.stringifyTextNode = function (textNode) {
   return Foundation.HTML.Beautifier.escapeText(textNode.data);
 };

 /**
  * Turn a DOM tag node into a string.
  * @private
  * @param {Element} tag
  * @return {string}
  */
 Foundation.HTML.Beautifier.stringifyTagNode = function (tag) {
   var s = `<${tag.tagName.toLowerCase()}`;

   if (tag.attributes) {
     for (var i = 0; i < tag.attributes.length; i++) {
       var attr = /** @type {Attr} */ (tag.attributes.item(i));
       s += ` ${Foundation.HTML.Beautifier.stringifyAttribute(attr)}`;
     }
   }

   return `${s}>`;
 };

/**
 * Returns true if the given tag should have newline separation before and
 * after it.
 * @private
 * @param {string} tag
 * @return {boolean}
 */
 Foundation.HTML.Beautifier.tagNeedsSectionalTreatment = function (tag) {
   var rules = Foundation.HTML.Beautifier.rulesForTag(tag);
   return !!(rules & Foundation.HTML.Beautifier.TagRule.SECTIONAL);
 };

/**
 * Returns true when the tag should have a corresponding closing tag.
 * @private
 * @param {string} tag
 * @return {boolean}
 */
Foundation.HTML.Beautifier.tagNeedsClosingTag = function (tag) {
   var rules = Foundation.HTML.Beautifier.rulesForTag(tag);
   return !(rules & Foundation.HTML.Beautifier.TagRule.VOID);
};

/**
 * Returns true when the tag should have its contents indented.
 * @private
 * @param {string} tag
 * @return {boolean}
 */
Foundation.HTML.Beautifier.tagNeedsIndentation = function (tag) {
   var rules = Foundation.HTML.Beautifier.rulesForTag(tag);
   return !!(rules & Foundation.HTML.Beautifier.TagRule.INDENTS);
};

/**
 * Returns true when a tag is the first among its parents children.
 * @param {Node} node
 * @return {boolean}
 */
Foundation.HTML.Beautifier.nodeIsFirst = function (node) {
  var parent = node.parentNode;
  return !parent || (parent && parent.firstChild === node);
};

/**
 * Returns true when a tag is the last among its parents children.
 * @param {Node} node
 * @return {boolean}
 */
Foundation.HTML.Beautifier.nodeIsLast = function (node) {
  var parent = node.parentNode;
  return !parent || (parent && parent.lastChild === node);
};

/**
 * Bitfield for containing multiple tag rules.
 * @typedef {number}
 */
Foundation.HTML.Beautifier.TagRules = {};

/**
 * TagRules bitfield definitions.
 * @enum {number}
 */
Foundation.HTML.Beautifier.TagRule = {
  NONE: 0x0,
  SECTIONAL: 0x1,
  INDENTS: 0x2,
  VOID: 0x4       // aka, nonclosable tags like <br>.
};

 /**
  * Return the beautification rules for a given tag.
  * @private
  * @param {string} tag
  * @return {Foundation.HTML.Beautifier.TagRules}
  */
Foundation.HTML.Beautifier.rulesForTag = function (tag) {
  var rules = Foundation.HTML.Beautifier.tagRules();
  var rule = rules[tag.toLowerCase()];
  if (rule) {
    return rule;
  }
  else {
    return Foundation.HTML.Beautifier.TagRule.NONE;
  }
};

/**
 * @private
 * @return {Object.<string,Foundation.HTML.Beautifier.TagRules>}
 */
Foundation.HTML.Beautifier.tagRules = function () {
  if (!Foundation.HTML.Beautifier._rules) {
    var sectionalTags = [
      "html", "head", "title", "body",
      "section", "nav", "article", "aside", "header", "footer",
      "style", "script", "noscript", "iframe",
      "div", "p", "section", "h1", "h2", "h3", "h4", "h5", "h6",
      "dialog", "blockquote", "ol", "ul", "li", "dt", "dd",
      "object", "video", "audio", "canvas",
      "table", "caption", "colgroup", "col", "tbody", "thead", "tfoot", "tr", "td", "th",
      "form", "fieldset", "select", "datalist", "optgroup", "textarea", "output"
    ];

    var indentationalTags = [
      "html", "head", "body",
      "section", "nav", "article", "aside", "header", "footer",
      "noscript", "iframe",
      "div", "p",
      "dialog", "blockquote", "ol", "ul", "dl",
      "figure", "object", "video", "audio",
      "table", "caption", "colgroup", "col", "tbody", "thead", "tfoot", "tr", "td", "th",
      "form", "fieldset", "select", "datalist", "optgroup"
    ];

    var voidTags = Foundation.HTML.voidTags();

    // Initialize rules
    var rules = Foundation.HTML.Beautifier._rules = {};
    [sectionalTags, indentationalTags, voidTags].forEach(function (tagList) {
      tagList.forEach(function (tag) {
        rules[tag] = Foundation.HTML.Beautifier.TagRule.NONE;
      });
    });

    sectionalTags.forEach(function (tag) {
      rules[tag] = rules[tag] | Foundation.HTML.Beautifier.TagRule.SECTIONAL;
    });

    indentationalTags.forEach(function (tag) {
      rules[tag] = rules[tag] | Foundation.HTML.Beautifier.TagRule.INDENTS;
    });

    voidTags.forEach(function (tag) {
      rules[tag] = rules[tag] | Foundation.HTML.Beautifier.TagRule.VOID;
    });
  }

  return Foundation.HTML.Beautifier._rules;
}

// ---------------------------------------------------------------------

window["Foundation"]["HTML"]["Beautifier"] = Foundation.HTML.Beautifier;
window["Foundation"]["HTMLBeautifier"] = Foundation.HTML.Beautifier;  // Backwards compatability.
Foundation.HTML.Beautifier.prototype["beautify"] = Foundation.HTML.Beautifier.prototype.beautify;
Foundation.HTML.Beautifier.prototype["setIndentationString"] = Foundation.HTML.Beautifier.prototype.setIndentationString;
